// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7648":"a38d7692","9977":"91933a9d"}[chunkId] + ".chunk.css";
};